import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { axiosPrivate } from '../../service/axiosPrivate';

const apiPath = 'users/accounts/';

const initialState = {
  isLoading: false,
  users: [],
  currentUser: {},
  currentUserDefault: {},
  error: null,
};

const getErrorMessage = error =>
  error?.response?.data?.message ||
  error?.response?.data?.detail ||
  error?.message ||
  'Xatolik yuz berdi';

export const getUsers = createAsyncThunk('users/get', async (_, { rejectWithValue }) => {
  try {
    const response = await axiosPrivate.get(apiPath);
    return response.data;
  } catch (error) {
    return rejectWithValue(getErrorMessage(error));
  }
});

export const getUserById = createAsyncThunk('users/getById', async (id, { rejectWithValue }) => {
  try {
    const response = await axiosPrivate.get(`${apiPath}${id}/`);
    return response.data;
  } catch (error) {
    return rejectWithValue(getErrorMessage(error));
  }
});

export const addUser = createAsyncThunk('users/add', async (user, { rejectWithValue }) => {
  try {
    const currentUser = await axiosPrivate.post(apiPath, user);
    const users = await axiosPrivate.get(apiPath);
    return { users: users.data, currentUser: currentUser.data.user };
  } catch (error) {
    return rejectWithValue(getErrorMessage(error));
  }
});

export const updateUser = createAsyncThunk(
  'users/update',
  async ({ id, user }, { rejectWithValue }) => {
    try {
      const response = await axiosPrivate.patch(`${apiPath}${id}/`, user);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

export const deleteUser = createAsyncThunk('users/delete', async (id, { rejectWithValue }) => {
  try {
    const response = await axiosPrivate.delete(`${apiPath}${id}/`);
    return response.data;
  } catch (error) {
    return rejectWithValue(getErrorMessage(error));
  }
});

export const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getUsers.pending, state => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getUsers.fulfilled, (state, action) => {
        state.users = action.payload || [];
        state.currentUser = action?.payload?.[0] || {};
        state.currentUserDefault = action?.payload?.[0] || {};
        state.isLoading = false;
      })
      .addCase(getUsers.rejected, (state, action) => {
        state.isLoading = false;
        state.users = [];
        state.error = action.payload;
      })
      .addCase(getUserById.pending, state => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getUserById.fulfilled, (state, action) => {
        state.currentUser = action.payload;
        state.currentUserDefault = action.payload;
        state.isLoading = false;
      })
      .addCase(getUserById.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(addUser.pending, state => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(addUser.fulfilled, (state, action) => {
        state.users = action.payload.users || [];
        state.currentUser = action.payload.currentUser || {};
        state.currentUserDefault = action.payload.currentUser || {};
        state.isLoading = false;
      })
      .addCase(addUser.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(updateUser.pending, state => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateUser.fulfilled, (state, action) => {
        state.currentUser = action.payload;
        state.currentUserDefault = action.payload;
        state.isLoading = false;
      })
      .addCase(updateUser.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(deleteUser.pending, state => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(deleteUser.fulfilled, (state, action) => {
        state.users = action.payload || [];
        state.currentUser = action?.payload?.[0] || {};
        state.currentUserDefault = action?.payload?.[0] || {};
        state.isLoading = false;
      })
      .addCase(deleteUser.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

const { reducer } = usersSlice;

export default reducer;
